module.exports = __webpack_public_path__ + "img/location.0c5c42ea.png";